import {ReactElement, useEffect} from 'react';
import {MessageReceiver} from 'interactors/messageBus';
import {fallbackResponse} from './fallbackResponse';
import {useModalClose} from './useModalClose';
import {eventsRegistry, Events} from './events';

interface MessagesReceiverProps {
  receiver?: Receiver;
  events?: Events;
}

export const MessagesReceiver = ({
  receiver = MessageReceiver,
  events = eventsRegistry,
}: MessagesReceiverProps): ReactElement => {
  const closeCurrentModal = useModalClose({fallbackResponse});

  useEffect(() => {
    receiver.register();
    receiver.on(events.backButtonPressed, closeCurrentModal);

    return () => {
      receiver.off(events.backButtonPressed, closeCurrentModal);
    };
  }, [receiver, closeCurrentModal, events]);

  return null;
};
